import styled from "@emotion/styled";
import { Skeleton } from "@repo/skapa";

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
`;

const SkeletonBlock = styled.div`
  margin-bottom: 12px;
`;

export const ProjectsPageSkeleton = () => {
  return (
    <>
      <HeaderRow>
        <Skeleton height="32px" width="150px" />
        <Skeleton height="32px" width="120px" />
      </HeaderRow>
      <SkeletonBlock>
        <Skeleton height="50px" width="100%" />
      </SkeletonBlock>
      <SkeletonBlock>
        <Skeleton height="50px" width="100%" />
      </SkeletonBlock>
    </>
  );
};
